import loadable from '@loadable/component';

export const OrgDashboardMembershipLoadable = loadable(
  () => import('./OrgDashboardMembership'),
  {
    resolveComponent: (module) => module.OrgDashboardMembership,
    ssr: false,
  },
);
